module.exports = __webpack_public_path__ + "img/engineeringCases2.26eb4baa.png";